module.exports = __webpack_public_path__ + "img/hands-and-gestures.f616d385.svg";